import { addDoc, collection, doc, getDocs, query, updateDoc, where } from 'firebase/firestore';
import { db } from '../../firebase';
import { parseContents } from '../utils';
import { ProjectErrorType } from '../../utils/errors/types';
import { getProjectErrorFromRawError } from '../../utils/errors';
import { FormQuestion, FormQuestionType } from '../types/forms';
import { parseFormQuestions } from './parser';
import { CreateFormQuestionDto, UpdateFormQuestionDto } from '../typeDtos/forms';

export const getAllFormQuestions = async ({
  formQuestionType,
}: {
  formQuestionType: FormQuestionType;
}): Promise<FormQuestion[]> => {
  try {
    const _query = query(collection(db, 'questions'), where('type', '==', formQuestionType));
    const rawResult = await getDocs(_query);
    return await parseFormQuestions(parseContents(rawResult));
  } catch (error) {
    console.log('[FORM QUESTIONS] Error at getAllFormQuestions:', error);
    return [];
  }
};

export const createFormQuestion = async (
  data: CreateFormQuestionDto,
): Promise<ProjectErrorType | { success: boolean }> => {
  try {
    const nowTs = new Date().getTime();
    const _data = { ...data, createdAt: nowTs, updatedAt: nowTs };
    await addDoc(collection(db, 'questions'), _data);
    return { success: true };
  } catch (e) {
    console.log('[FORM QUESTIONS] Error at createFormQuestion:', e);
    return getProjectErrorFromRawError(e as Error);
  }
};

export const updateFormQuestion = async (
  data: UpdateFormQuestionDto,
): Promise<ProjectErrorType | { success: boolean }> => {
  try {
    const nowTs = new Date().getTime();
    const _data = { ...data, updatedAt: nowTs };
    const docRef = doc(db, 'questions', _data?.id);
    await updateDoc(docRef, _data);
    return { success: true };
  } catch (e) {
    console.log('[FORM QUESTIONS] Error at updateFormQuestion:', e);
    return getProjectErrorFromRawError(e as Error);
  }
};
